import React from 'react';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { ReactComponent as Icon } from '#web-components/assets/icons/task.svg';

import styles from './TaskIcon.styles';

type TaskIconProps = {
  className?: string;
};

const useStyles = makeStyles(styles, { name: 'TaskIcon' });

export default function TaskIcon({ className }: TaskIconProps) {
  const classes = useStyles();
  return (
    <span className={clsx(classes.icon, className)}>
      <Icon />
    </span>
  );
}
